/**
 * Drawer localization schema.
 * Defines all translation strings for the navigation drawer sections and items.
 *
 * @drawer_header @app_name Display name of the application in the drawer header.
 * @drawer_sections @section @title Section title displayed in the drawer (optional in rail mode).
 * @drawer_sections @section @drawer_items @title title Drawer item visible title.
 * @drawer_sections @section @drawer_items @tooltip_text Drawer item tooltip shown on hover.
 */
export default {
  // Group Labels
  laboratory: "Лаборатория",

  // Drawer Header
  drawer_header: {
    app_name: "Ирис",
  },

  // Drawer Sections
  drawer_sections: {
    // Operational Section
    operational_section: {
      // Section Title
      title: "Операционен раздел",

      // Operational Items
      drawer_items: {
        channels: {
          title: "Канали",
          tooltip_text: "Наблюдение и управление на инструментални връзки",
        },
        instruments: {
          title: "Апарати",
          tooltip_text: "Списък и конфигурация на апарати",
        },
        validation: {
          title: "Валидация",
          tooltip_text: "Преглед и валидация на QC резултати",
        },
      },
    },

    // Administrative Section
    administrative_section: {
      // Section Title
      title: "Административен раздел",

      // Administrative Items
      drawer_items: {
        locations: {
          title: "Локации",
          tooltip_text: "Управление на физическите локации",
        },
        instruments: {
          title: "Апарати",
          tooltip_text: "Списък и конфигурация на всички апарати",
        },
      },
    },

    // About Section
    about_section: {
      // About Items
      drawer_items: {
        about: {
          title: "Относно",
          tooltip_text: "Информация за приложението",
        },
      },
    },
  },
};
